/** @deprecated We should eventually eliminate non-flex owner accounts */
export class NonFlexAccountRequestModel {
    accountName;
    sharingAccountIds;
    docSizeSetting;
    utilizationSettings;
}
export class LogsAccountRequestModel {
    accountName;
    accessible;
    searchable;
    maxDailyGB;
    softLimitGB;
    snapSearchRetentionDays;
    retentionDays;
    docSizeSetting;
    utilizationSettings;
    sharingObjectsAccounts;
    reservedDailyGB;
    isFlexible;
    email;
}
export class LogsAccountResponseModel {
    accountId;
    accountToken;
}
//# sourceMappingURL=logs-account-request.js.map